<script lang="ts">
  import { swState } from "$lib/sw.svelte";
</script>

<div class="sw_popup_offline" class:active={swState.connectivity.active} id="sw-toast-offline">
  {swState.connectivity.text}
</div>

<style>
  @keyframes fade_in_out {
    0% {
      transform: translate(50%, -100%);
    }
    10% {
      transform: translate(50%, 0);
    }
    90% {
      transform: translate(50%, 0);
    }
    100% {
      transform: translate(50%, -100%);
    }
  }
  .sw_popup_offline {
    position: absolute;
    top: 0;
    right: 50%;
    height: 60px;
    width: 200px;
    display: flex;
    flex-direction: column;
    color: white;
    justify-content: center;
    align-items: center;
    background-color: black;
    transform: translate(50%, -100%);
    gap: 20px;
    animation: none;
    z-index: 999;
  }

  .sw_popup_offline.active {
    animation: fade_in_out 3s linear;
  }
</style>
